module.exports = __webpack_public_path__ + "cjml_app_pcui/img/pic_Identifying.c442ba59.gif";